module.exports = "images/-18.981a35f8.png";